export enum ActionType {
  GET_FOOD_TRAY_TEMPLATES = 'GET_FOOD_TRAY_TEMPLATES',
  GET_FOOD_TRAY_TEMPLATES_REJECTED = 'GET_FOOD_TRAY_TEMPLATES_REJECTED',
  GET_FOOD_TRAY_TEMPLATES_FULFILLED = 'GET_FOOD_TRAY_TEMPLATES_FULFILLED',
  GET_FOOD_TRAY_TEMPLATE = 'GET_FOOD_TRAY_TEMPLATE',
  CLEAR_FOOD_TRAY_TEMPLATE = 'CLEAR_FOOD_TRAY_TEMPLATE',
  GET_FOOD_TRAY_TEMPLATE_REJECTED = 'GET_FOOD_TRAY_TEMPLATE_REJECTED',
  GET_FOOD_TRAY_TEMPLATE_FULFILLED = 'GET_FOOD_TRAY_TEMPLATE_FULFILLED',
  DUPLICATE_FOOD_TRAY_TEMPLATE = 'DUPLICATE_FOOD_TRAY_TEMPLATE',
  DUPLICATE_FOOD_TRAY_TEMPLATE_REJECTED = 'DUPLICATE_FOOD_TRAY_TEMPLATE_REJECTED',
  DUPLICATE_FOOD_TRAY_TEMPLATE_FULFILLED = 'DUPLICATE_FOOD_TRAY_TEMPLATE_FULFILLED',
  DELETE_FOOD_TRAY_TEMPLATE = 'DELETE_FOOD_TRAY_TEMPLATE',
  DELETE_FOOD_TRAY_TEMPLATE_REJECTED = 'DELETE_FOOD_TRAY_TEMPLATE_REJECTED',
  DELETE_FOOD_TRAY_TEMPLATE_FULFILLED = 'DELETE_FOOD_TRAY_TEMPLATE_FULFILLED',
  CREATE_FOOD_TRAY_TEMPLATE = 'CREATE_FOOD_TRAY_TEMPLATE',
  CREATE_FOOD_TRAY_TEMPLATE_REJECTED = 'CREATE_FOOD_TRAY_TEMPLATE_REJECTED',
  CREATE_FOOD_TRAY_TEMPLATE_FULFILLED = 'CREATE_FOOD_TRAY_TEMPLATE_FULFILLED',
  UPDATE_FOOD_TRAY_TEMPLATE = 'UPDATE_FOOD_TRAY_TEMPLATE',
  UPDATE_FOOD_TRAY_TEMPLATE_REJECTED = 'UPDATE_FOOD_TRAY_TEMPLATE_REJECTED',
  UPDATE_FOOD_TRAY_TEMPLATE_FULFILLED = 'UPDATE_FOOD_TRAY_TEMPLATE_FULFILLED',
  START_TIMER = 'START_TIMER',
  START_TIMER_REJECTED = 'START_TIMER_REJECTED',
  START_TIMER_FULFILLED = 'START_TIMER_FULFILLED',
  START_TIMER_FOR_EXISTING_FOOD_ITEM = 'START_TIMER_FOR_EXISTING_FOOD_ITEM',
  START_TIMER_FOR_EXISTING_FOOD_ITEM_REJECTED = 'START_TIMER_FOR_EXISTING_FOOD_ITEM_REJECTED',
  START_TIMER_FOR_EXISTING_FOOD_ITEM_FULFILLED = 'START_TIMER_FOR_EXISTING_FOOD_ITEM_FULFILLED',
  REPLACE_FOOD_ITEM = 'REPLACE_FOOD_ITEM',
  REPLACE_FOOD_ITEM_REJECTED = 'REPLACE_FOOD_ITEM_REJECTED',
  REPLACE_FOOD_ITEM_FULFILLED = 'REPLACE_FOOD_ITEM_FULFILLED',
  REPLACE_FOOD_ITEM_AND_START_TIMER = 'REPLACE_FOOD_ITEM_AND_START_TIMER',
  REPLACE_FOOD_ITEM_AND_START_TIMER_REJECTED = 'REPLACE_FOOD_ITEM_AND_START_TIMER_REJECTED',
  REPLACE_FOOD_ITEM_AND_START_TIMER_FULFILLED = 'REPLACE_FOOD_ITEM_AND_START_TIMER_FULFILLED',
  EMPTY_ITEM = 'EMPTY_ITEM',
  EMPTY_ITEM_REJECTED = 'EMPTY_ITEM_REJECTED',
  EMPTY_ITEM_FULFILLED = 'EMPTY_ITEM_FULFILLED',
  EMPTY_LINE = 'EMPTY_LINE',
  EMPTY_LINE_REJECTED = 'EMPTY_LINE_REJECTED',
  EMPTY_LINE_FULFILLED = 'EMPTY_LINE_FULFILLED',
}

export default ActionType;
